export interface PanelProgressBarProps {
  props: { value: number; max?: number; label?: string };
}

export function PanelProgressBar({ props }: PanelProgressBarProps) {
  const { value, max = 100, label } = props;
  const pct = Math.min(100, Math.max(0, (value / max) * 100));

  return (
    <div className="space-y-1">
      {label && (
        <div className="flex items-center justify-between">
          <span className="text-sd-xs text-sd-text-secondary">{label}</span>
          <span className="text-sd-xs text-sd-text-muted tabular-nums">
            {Math.round(pct)}%
          </span>
        </div>
      )}
      <div className="w-full h-1.5 bg-sd-surface-elevated rounded-sd-full overflow-hidden">
        <div
          className="h-full bg-sd-warning rounded-sd-full transition-all duration-500"
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin={0}
          aria-valuemax={max}
        />
      </div>
    </div>
  );
}
